import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000';

const getAuthHeaders = () => {
  const token = localStorage.getItem("clerkToken");
  return {
    Authorization: `Bearer ${token}`,
  };
};

export const fetchVehicleVersions = (vin) =>
  axios.get(`${BASE_URL}/search/vehicle-versions`, {
    params: { vin },
    headers: getAuthHeaders(),
  });

export const fetchVehicleAnalysis = (params) =>
  axios.post(`${BASE_URL}/search/vehicle-analysis`, {
    make: params.make,
    mileage: params.mileage,
    model: params.model,
    radius: params.radius || 100,
    trim: params.trim,
    version: params.version,
    vin: params.vin,
    year: params.year,
  }, {
    headers: {
      ...getAuthHeaders(),
      'Content-Type': 'application/json',
      'accept': 'application/json',
    },
  });

export const addToWatchlist = (payload) =>
  axios.post(`${BASE_URL}/watchlist`, payload, {
    headers: {
      ...getAuthHeaders(),
      'Content-Type': 'application/json',
      'accept': 'application/json',
    },
  });export const removeFromWatchlist = (vin) =>
  axios.delete(`${BASE_URL}/watchlist/by-vin/${vin}`, {
    headers: {
      ...getAuthHeaders(),
      'Content-Type': 'application/json',
      'accept': 'application/json',
    },
  });

export const fetchWatchlist = () =>
  axios.get(`${BASE_URL}/watchlist`, {
    headers: getAuthHeaders(),
  });
